import InfoLabel from "./InfoLabel";
import { useTexts } from "../../hooks";
import classes from "../../styles/InfoLabel.module.css";

// const FREE_MODE_CURRENCY = "LSL";
const FunPlayLabel: React.FC<{ visible: boolean }> = ({ visible }) => {
  const { common } = useTexts();
  // const currency = useAppSelector((state) => state.details.currency);

  if (!visible) return null;

  return (
    <InfoLabel shape="rectangle" className={classes["fun-mode"]}>
      <div>{common.funmode}</div>
    </InfoLabel>
  );
};

export default FunPlayLabel;
